import React, { FC } from 'react'

import { InterSvgIcon } from 'components'

import IcChevronRight from '@interco/icons/core/action-navigation/ic_chevron_right'

import {
  Container,
  DescriptionArea,
  IconContainer,
  ServiceButtonContainer,
  ServiceButtonTitle,
  TitleContainer,
  UpdateInfo,
} from '../styles/ServiceButton.styles'
import { TServiceButtonContent } from '../types/ServiceButton.types'

const homeIconStyle = {
  width: 24,
  height: 24,
  color: 'var(--typography500)',
}

export const ServiceButtonView: FC<TServiceButtonContent> = ({
  icon,
  title,
  children,
  hasUpdate = false,
  navigateTo,
}) => (
  <Container onClick={navigateTo} data-testid="service-button-container">
    <ServiceButtonContainer>
      <IconContainer>
        <InterSvgIcon
          iconRef={icon}
          width={homeIconStyle.width}
          height={homeIconStyle.height}
          color={homeIconStyle.color}
        />
      </IconContainer>
      <DescriptionArea>
        {title && (
          <TitleContainer>
            <ServiceButtonTitle variant="body-3" color="typography" colorWeight={500} as="p">
              {title}
            </ServiceButtonTitle>
            {hasUpdate && <UpdateInfo />}
          </TitleContainer>
        )}
        {children}
      </DescriptionArea>
      <IcChevronRight color="var(--secondary500)" width={24} height={24} />
    </ServiceButtonContainer>
  </Container>
)
